// Data maps (no colour space, opaque) decoded from the file's bytes, which the
// browser does off the main thread, and uploaded from an ImageBitmap. From an
// <img> the decode ran on the main thread inside the upload: the 4096 x 2048
// sky map held a mid-range phone's main thread for 550 ms in one frame, and a
// tap then waited for it. WebGL ignores the upload's flip for an ImageBitmap,
// so the decode does it, and the texels are the <img>'s byte for byte. The
// bitmap is let go once uploaded, as the browser lets an <img>'s decode go.
import * as THREE from 'three';

let flipTest = null;

// Whether this browser flips an ImageBitmap when asked; where it does not, the
// map would be drawn upside down, so the <img> path is kept there.
export function bitmapFlips() {
  if (!flipTest) {
    flipTest = (async () => {
      const src = document.createElement('canvas');
      src.width = 1; src.height = 2;
      const sx = src.getContext('2d');
      sx.fillStyle = '#ff0000'; sx.fillRect(0, 0, 1, 1);
      sx.fillStyle = '#0000ff'; sx.fillRect(0, 1, 1, 1);
      const bitmap = await createImageBitmap(src, { imageOrientation: 'flipY' });
      const out = document.createElement('canvas');
      out.width = 1; out.height = 2;
      const ox = out.getContext('2d', { willReadFrequently: true });
      ox.drawImage(bitmap, 0, 0);
      bitmap.close();
      const top = ox.getImageData(0, 0, 1, 1).data;
      return top[2] > 200 && top[0] < 50;
    })().catch(() => false);
  }
  return flipTest;
}

export async function loadDataMapTexture(url) {
  // Made before anything is awaited, where TextureLoader made its texture,
  // so objects come in the same order as before: the video renderer seeds
  // Math.random, which three draws from for every object.
  const texture = new THREE.Texture();
  if (typeof createImageBitmap === 'function' && typeof fetch === 'function' && await bitmapFlips()) {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const bitmap = await createImageBitmap(await res.blob(), {
        imageOrientation: 'flipY', premultiplyAlpha: 'none', colorSpaceConversion: 'none',
      });
      texture.image = bitmap;
      texture.flipY = false;
      texture.onUpdate = () => {
        texture.onUpdate = null;
        bitmap.close();
      };
      texture.needsUpdate = true;
      return texture;
    } catch (_) {
      // The <img> path below.
    }
  }
  return new THREE.TextureLoader().loadAsync(url);
}
